import { Box, Divider } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { useForm, UseFormReturn, useWatch } from 'react-hook-form';
import { LoanFormType } from 'views/orders/loans/types';

import { ConditionForm } from '../condition-form';
import { ConditionsForm } from './types';
import { formatConditionsForm, getValues } from './utils';

type Props = {
  loanForm: UseFormReturn<LoanFormType, object>;
  onSave: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
}

export const IncreaseInterestRateConditions: FC<Props> = ({ loanForm, onSave }) => {
  const { control } = loanForm;
  const { increase_interest_rate_text } = useWatch({ control });

  const conditionForm = useForm<ConditionsForm>({ mode: 'onChange' });

  const { control: conditionFormControl } = conditionForm;
  const {
    firstConditionExist,
    secondConditionExist,
    firstFieldValues,
    secondFieldValues
  } = useWatch({ control: conditionFormControl });

  useEffect(() => {
    conditionForm.reset(getValues(increase_interest_rate_text));
  }, [conditionForm, increase_interest_rate_text]);

  const saveForm = () => {
    loanForm.setValue('increase_interest_rate_text', formatConditionsForm(conditionForm.getValues()), { shouldDirty: true });
    onSave();
  };

  return (
    <Box>
      {firstConditionExist && (
        <>
          <ConditionForm
            conditionsFields={[
              {
                prefix: 'Adjust every ',
                value: firstFieldValues?.years,
                sufix: 'years',
                onChange: (value) => {
                  conditionForm.setValue('firstFieldValues.years', value);
                  saveForm();
                },
                onBlur: () => { onSave(); }
              },
              {
                prefix: 'starting in year ',
                value: firstFieldValues?.year,
                format: '####',
                onChange: (value) => {
                  conditionForm.setValue('firstFieldValues.year', value);
                  saveForm();
                },
                onBlur: () => { onSave(); }
              }
            ]}
            onRemove={() => {
              conditionForm.setValue('firstConditionExist', false);
              conditionForm.setValue('firstFieldValues', {
                year: undefined,
                years: undefined
              });
              saveForm();
            }}
          />
        </>
      )}
      {secondConditionExist && (
        <>
          <Divider />
          <ConditionForm
            conditionsFields={[
              {
                prefix: 'Can go as high as ',
                value: secondFieldValues?.percent,
                sufix: '% ',
                onChange: (value) => {
                  conditionForm.setValue('secondFieldValues.percent', value);
                  saveForm();
                },
                onBlur: () => { onSave(); }
              },
              {
                prefix: ' in year ',
                value: secondFieldValues?.year,
                format: '####',
                onChange: (value) => {
                  conditionForm.setValue('secondFieldValues.year', value);
                  saveForm();
                },
                onBlur: () => { onSave(); }
              }
            ]}
            onRemove={() => {
              conditionForm.setValue('secondConditionExist', false);
              conditionForm.setValue('secondFieldValues', {
                percent: undefined,
                year: undefined
              });
              saveForm();
            }}
          />
        </>
      )}
    </Box>
  );
};
